<template>
  <div id="dragBox">
    <vue-dropzone ref="myVueDropzone" :id="id"
                  @vdropzone-file-added="vfileAdded"
                  @vdropzone-success="vsuccess"
                  @vdropzone-error="verror"
                  @vdropzone-removed-file="vremoved"
                  @vdropzone-sending="vsending"
                  @vdropzone-success-multiple="vsuccessMuliple"
                  @vdropzone-sending-multiple="vsendingMuliple"
                  @vdropzone-queue-complete="vqueueComplete"
                  @vdropzone-total-upload-progress="vprogress"
                  @vdropzone-mounted="vmounted"
                  @vdropzone-drop="vddrop"
                  @vdropzone-drag-start="vdstart"
                  @vdropzone-drag-end="vdend"
                  @vdropzone-drag-enter="vdenter"
                  @vdropzone-drag-over="vdover"
                  @vdropzone-drag-leave="vdleave"
                  @vdropzone-duplicate-file="vdduplicate"
                  :options="dropzoneOptions"
                  :duplicateCheck="true">
    </vue-dropzone>
  </div>
</template>
<script>
import vue2Dropzone from 'vue2-dropzone'
import 'vue2-dropzone/dist/vue2Dropzone.min.css'
export default{
  props: ['id', 'type', 'amount', 'imgList'],
  components: {
    vueDropzone: vue2Dropzone
  },
  data () {
    return {
      image: [],
      img: {
        width: 0,
        height: 0
      },
      ok: true,
      example: '測試測試測試',
      dropzoneOptions: {
        url: 'https://httpbin.org/post',
        thumbnailWidth: 150,
        maxFilesize: 2,
        maxFiles: this.amount,
        addRemoveLinks: true,
        uploadMultiple: false,
        timeout: 3000
      },
      fileAdded: false,
      filesAdded: false,
      success: false,
      error: false,
      removedFile: false,
      sending: false,
      successMultiple: false,
      sendingMultiple: false,
      queueComplete: false,
      uploadProgress: false,
      progress: false,
      myProgress: 0,
      isMounted: false,
      dDrop: false,
      dStarted: false,
      dEnded: false,
      dEntered: false,
      dOver: false,
      dLeave: false,
      dDuplicate: false
    }
  },
  methods: {
    vfileAdded (file) {
      this.fileAdded = true
      // window.toastr.info('', 'Event : vdropzone-file-added')
    },
    vfilesAdded (file) {
      this.filesAdded = true
      // window.toastr.info('', 'Event : vdropzone-files-added')
    },
    vsuccess (file, response) {
      this.success = true
      // window.toastr.success('', 'Event : vdropzone-success')
    },
    verror (file, message, xhr) {
      this.error = true
      console.log('error', file)
      // 上傳至佔位 url 失敗屬預期行為 (圖片是存進 image 由父元件送出)，不顯示錯誤樣式；
      // 無 xhr 表示本地檢核錯誤 (如檔案超過 2MB)，仍需保留提示
      if (xhr && file.previewElement) file.previewElement.classList.remove('dz-error')
      const alreadyAdded = this.image.some(function (o) { return o.name === file.name })
      if (!alreadyAdded) this.createImage(file)
      // window.toastr.error(file.upload.filename, 'Event : vdropzone-error - ' + file.status)
    },
    vremoved (file, xhr, error) {
      this.removedFile = true
      this.$nextTick(() => this.removeImage(file))
      // window.toastr.warning('', 'Event : vdropzone-removedFile')
    },
    vsending (file, xhr, formData) {
      this.sending = true
      console.log('send', file)
      this.createImage(file)
      // window.toastr.warning('', 'Event : vdropzone-sending')
    },
    vsuccessMuliple (files, response) {
      this.successMultiple = true
      console.log('vsuccessMuliple')
      // window.toastr.success('', 'Event : vdropzone-success-multiple')
    },
    vsendingMuliple (file, xhr, formData) {
      this.sendingMultiple = true
      console.log('vsendingMuliple', file)
      // window.toastr.warning('', 'Event : vdropzone-sending-multiple')
    },
    vqueueComplete (file, xhr, formData) {
      this.queueComplete = true
      console.log('complete', file)
      // window.toastr.success('', 'Event : vdropzone-queue-complete')
    },
    vprogress (totalProgress, totalBytes, totalBytesSent) {
      this.progress = true
      this.myProgress = Math.floor(totalProgress)
      console.log('vprogress')
      // window.toastr.success('', 'Event : vdropzone-sending')
    },
    vmounted () {
      console.log('vmounted')
      this.isMounted = true
    },
    vddrop () {
      this.dDrop = true
    },
    vdstart () {
      this.dStarted = true
    },
    vdend () {
      this.dEnded = true
    },
    vdenter () {
      this.dEntered = true
    },
    vdover () {
      this.dOver = true
    },
    vdleave () {
      this.dLeave = true
    },
    vdduplicate () {
      this.dDuplicate = true
      alert('請勿上傳相同檔名！')
    },
    removeImage (file) {
      if (!this.dDuplicate) {
        var index = this.image.findIndex(function (o) { return o.name === file.name })
        if (index > -1) this.image.splice(index, 1)
      }
    },
    createImage (file) {
      var reader = new FileReader()
      var self = this
      reader.onload = (e) => {
        var img = new Image()
        img.src = e.target.result
        var obj = { name: file.name, src: img.src, file: file }
        // $('#img-load' + this.index + '-' + this.type).attr('src', img.src)
        img.onload = () => {
          self.img.width = img.width
          self.img.height = img.height
          let valid = self.checkImgSize()

          if (valid) self.image.push(obj)
          else this.$refs.myVueDropzone.removeFile(file)
        }
      }
      // $('.img-size').css('background', 'white')
      reader.readAsDataURL(file)
    },
    checkImgSize () {
      let valid = true
      var self = this
      if (this.type === 1) {
        if ((this.img.width !== 80 || this.img.height !== 60) && this.img.width !== 0 && this.img.height !== 0 && this.$route.name !== 'crCategoryImg') {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳80x60之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          valid = false
        }

        /* else if ((this.img.width !== 800 || this.img.height !== 210) && this.img.width !== 0 && this.img.height !== 0 && this.$route.name === 'crCategoryImg') {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x210之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
        } */
      } else if (this.type === 2) {
        if ((this.img.width !== 800 || this.img.height !== 600) && this.img.width !== 0 && this.img.height !== 0) {
          this.$notify({
            title: '提醒',
            text: '圖片尺寸為' + self.img.width + 'x' + self.img.height + '，請上傳800x600之圖片！',
            duration: 3000,
            type: 'danger',
            width: 400
          })
          valid = false
        }
      }

      return valid
    }
  },
  watch: {
    fileAdded () {
      let that = this
      setTimeout(function () {
        that.fileAdded = false
      }, 2000)
    },
    filesAdded () {
      let that = this
      setTimeout(function () {
        that.filesAdded = false
      }, 2000)
    },
    success () {
      let that = this
      setTimeout(function () {
        that.success = false
      }, 2000)
    },
    error () {
      let that = this
      setTimeout(function () {
        that.error = false
      }, 2000)
    },
    removedFile () {
      let that = this
      setTimeout(function () {
        that.removedFile = false
      }, 2000)
    },
    sending () {
      let that = this
      setTimeout(function () {
        that.sending = false
      }, 2000)
    },
    successMultiple () {
      let that = this
      setTimeout(function () {
        that.successMultiple = false
      }, 2000)
    },
    sendingMultiple () {
      let that = this
      setTimeout(function () {
        that.sendingMultiple = false
      }, 2000)
    },
    queueComplete () {
      let that = this
      setTimeout(function () {
        that.queueComplete = false
      }, 2000)
    },
    progress () {
      let that = this
      setTimeout(function () {
        that.progress = false
      }, 2000)
    },
    isMounted () {
      let that = this
      setTimeout(function () {
        that.isMounted = false
      }, 2000)
    },
    dDrop () {
      let that = this
      setTimeout(function () {
        that.dDrop = false
      }, 2000)
    },
    dStarted () {
      let that = this
      setTimeout(function () {
        that.dStarted = false
      }, 2000)
    },
    dEnded () {
      let that = this
      setTimeout(function () {
        that.dEnded = false
      }, 2000)
    },
    dEntered () {
      let that = this
      setTimeout(function () {
        that.dEntered = false
      }, 2000)
    },
    dOver () {
      let that = this
      setTimeout(function () {
        that.dOver = false
      }, 2000)
    },
    dLeave () {
      let that = this
      setTimeout(function () {
        that.dLeave = false
      }, 2000)
    },
    dDuplicate () {
      let that = this
      setTimeout(function () {
        that.dDuplicate = false
      }, 2000)
    },
    image () {
      if (typeof this.imgList !== 'undefined') {
        if (this.type === 1) this.imgList.smImgList = this.image
        else if (this.type === 2) this.imgList.lgImgList = this.image
      }
    }
  }
}
</script>
<style lang="sass">
  // 建立 stacking context，將 dropzone 內部的 z-index (dz-progress、dz-error-message 皆為 1000)
  // 侷限在此容器內，避免遮蓋外部元素 (例如 multiselect 展開的 dropdown，z-index 僅 50)
  #dragBox
    position: relative
    z-index: 0

  .dz-preview
    min-width: 150px !important
    min-height: 150px !important

  // 錯誤訊息不吃點擊，避免擋住底下的移除連結
  .dz-error-message
    pointer-events: none !important

  // 移除連結原生 z-index 為 30，會被 dz-error-message (1000) 蓋住而無法點擊
  .dz-preview .dz-remove
    z-index: 1001 !important
</style>



// WEBPACK FOOTER //
// ImgUpdateDropTemp.vue?ec11557c